import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Grid,
  Box,
  Button,
  CircularProgress,
} from "@mui/material";
import instance from "../utils/axiosInstance";
import { useNavigate } from "react-router-dom";
import { getMetaFromTokenURI, getIpfsUrl } from "../utils/meta_in_token";
import NFTCard from "../components/NFTCard";

const Home = () => {
  const navigate = useNavigate();
  const [allNFTs, setAllNFTs] = useState([]);
  const [saleNFTs, setSaleNFTs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNFTs = async () => {
      try {
        const allRes = await instance.get("/list?sort=views&order=desc&limit=5");
        const saleRes = await instance.get("/list?isSale=true&limit=5");

        const processNFTs = async (nfts) =>
          Promise.all(
            nfts.map(async (nft) => {
              const metadata = await getMetaFromTokenURI(nft.tokenURI);
              return {
                ...nft,
                name: metadata?.name || nft.name,
                description: metadata?.description || nft.description,
                displayImage: getIpfsUrl(metadata?.image),
              };
            })
          );

        setAllNFTs(await processNFTs(allRes.data.nfts));
        setSaleNFTs(await processNFTs(saleRes.data.nfts));
      } catch (err) {
        console.error(" NFT 불러오기 실패:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchNFTs();
  }, []);

  const renderSection = (title, nfts, link) => (
    <Box sx={{ mb: 8 }}>
      <Box 
        display="flex" 
        justifyContent="space-between" 
        alignItems="center" 
        mb={3} 
        sx={{ 
          borderBottom: "1px solid #bbb", 
          pb: 1 
        }}
      >
        <Typography variant="h5" fontWeight="bold">{title}</Typography>
        <Button onClick={() => navigate(link)}>전체보기 →</Button>
      </Box>
      {nfts.length === 0 ? (
        <Typography color="text.secondary" mt={2}>표시할 NFT가 없습니다.</Typography>
      ) : (
        <Grid container spacing={3}>
          {nfts.map((nft) => (
            <Grid item key={nft._id} sx={{ flexBasis: "20%", maxWidth: "20%" }}>
              <NFTCard item={nft} onClick={() => navigate(`/nft/${nft._id}`)} />
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );

  return (
    <Container maxWidth="lg" sx={{ mt: 6, mb: 10 }}>
      <Box
        sx={{
          textAlign: "center",
          py: 8,
          px: 4,
          backgroundColor: (theme) => theme.palette.background.banner,
          borderRadius: 4,
        }}
      >
        {/* 로고 + 슬로건을 가로 정렬 */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 3,           // 로고와 문구 사이 여백
            mb: 4,
          }}
        >
          {/* 로고 심볼 */}
          <Box
            component="img"
            src="/logo_ver_3.png"
            alt="ChainSpace Symbol"
            sx={{
              height: 100,      // 여기 조절하면서 크기 맞추면 돼
              width: "auto",
            }}
          />
          
          {/* 슬로건 */}
          <Box textAlign="left">
            <Typography variant="h4" fontWeight="bold">
              Create. Connect. Open.
            </Typography>
            <Typography variant="body1" color="text.secondary" mt={1}>
              당신의 콘텐츠를 세상과 연결하고 기회를 열어보세요.
            </Typography>
          </Box>
        </Box>

        {/* 버튼 */}
        <Button
          variant="contained"
          size="large"
          sx={{
            px: 20,
            py: 1.5,
            fontWeight: "bold",
            borderRadius: "999px",
          }}
          onClick={() => navigate("/nftcreate")}
        >
          내 창작물 NFT로 만들기 →
        </Button>
      </Box>


      {loading ? (
        <Box display="flex" justifyContent="center" mt={6}>
          <CircularProgress color="inherit" />
        </Box>
      ) : (
        <>
          {renderSection("인기 NFT", allNFTs, "/nftlist/1")}
          {renderSection("판매 중 NFT", saleNFTs, "/nftlist/1?isSale=true")}

        </>
      )}
    </Container>
  );
};

export default Home;
